// Login.js
import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from "./../services/http";

import logo from '../assets/smb-logo.png';

function Login({ setAuthToken }) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const SendForm = async (props) => {
    setLoading(true);
    try {
      const response = await axios.HTTP_POST("/api/usuarios/login", props);
      const { token } = response.data;
      setAuthToken(token);
      //const decodedToken = jwtDecode(token);
      localStorage.setItem('token', token);
      message.success('Inicio de sesión exitoso');
      navigate('/home');

    } catch(error) {
      message.error('Usuario o contraseña incorrectos');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='container-login'>
      <div className='login-wrapper'>
        <div className='login-logo'>
          <img src={logo} alt='SMB Logo' />
          <h2>Iniciar sesión</h2>
        </div>
        <Form layout='vertical' onFinish={SendForm}>
          <Form.Item name="usuario" label={"Usuario"} rules={[{ required: true, message: 'Favor de ingresar usuario' }]}>
            <Input placeholder='Ej. smb_usuario'/>
          </Form.Item>
          <Form.Item name="contrasena" label={"Contraseña"} rules={[{ required: true, message: 'Favor de ingresar contraseña' }]}>
            <Input.Password placeholder='Ej. ******'/>
          </Form.Item>
          <Form.Item>
            <Button className='btn-login' type="primary" htmlType="submit" loading={loading} block>
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default Login;
